import { useRepositoryMutation } from '@mews-commander/data-access';
import { lt, showSuccessAlert } from '@mews/framework';
import { useEnterpriseNavigate } from '@mews-commander/ui';

export const useAddTemplateMutation = () => {
    const navigate = useEnterpriseNavigate();
    return useRepositoryMutation('reservationContractTemplates', 'add', {
        invalidateQueries: {
            reservationContractTemplates: ['getAll'],
        },
        onSuccess: async () => {
            await navigate({ to: 'Settings/Contracts' });
            showSuccessAlert({
                title: lt('ContractTemplateAddedSuccessMessage'),
            });
        },
    });
};
